const HAS_SHOWN_RODEO_BUTTON_TUTORIAL_KEY = 'hasShownRodeoButtonTutorial'
const HAS_JOINED_CREATOR_WAITLIST_KEY = 'hasJoinedCreatorWaitlist'
const HAS_JOINED_APP_WAITLIST_KEY = 'hasJoinedAppWaitlist'
const TIMES_LAUNCHED_KEY = 'timesLaunched'
const TIMES_LAUNCHED_FOR_APP_WAITLIST_KEY = 'timesLaunchedForAppWaitlist'

const SENTINEL_VALUE = 'true'

const isSentinelValuePresentForKey = (key: string) => (): boolean =>
  !!localStorage.getItem(key)

const setSentinelValueForKey = (key: string) => () => {
  localStorage.setItem(key, SENTINEL_VALUE)
}

const getIntegerValueForKey = (key: string) => (): number => {
  const value = localStorage.getItem(key)

  if (!value) {
    return 0
  }

  const num = parseInt(value, 10)

  if (isNaN(num)) {
    return 0
  }

  return num
}

const incrementValueForKey = (key: string) => () => {
  const value = getIntegerValueForKey(key)()
  const newValue = value + 1
  localStorage.setItem(key, newValue.toString())
}

export const getHasShownRodeoButtonTutorial = isSentinelValuePresentForKey(
  HAS_SHOWN_RODEO_BUTTON_TUTORIAL_KEY
)

export const recordHasShownRodeoButtonTutorial = setSentinelValueForKey(
  HAS_SHOWN_RODEO_BUTTON_TUTORIAL_KEY
)

export const getHasJoinedCreatorWaitlist = isSentinelValuePresentForKey(
  HAS_JOINED_CREATOR_WAITLIST_KEY
)

export const recordHasJoinedCreatorWaitlist = setSentinelValueForKey(
  HAS_JOINED_CREATOR_WAITLIST_KEY
)

export const getHasJoinedAppWaitlist = isSentinelValuePresentForKey(
  HAS_JOINED_APP_WAITLIST_KEY
)

export const recordHasJoinedAppWaitlist = setSentinelValueForKey(
  HAS_JOINED_APP_WAITLIST_KEY
)

export const getTimesLaunched = getIntegerValueForKey(TIMES_LAUNCHED_KEY)

export const incrementTimesLaunched = incrementValueForKey(TIMES_LAUNCHED_KEY)

export const getTimesLaunchedForAppWaitlist = getIntegerValueForKey(
  TIMES_LAUNCHED_FOR_APP_WAITLIST_KEY
)

export const incrementTimesLaunchedforAppWaitlist = incrementValueForKey(
  TIMES_LAUNCHED_FOR_APP_WAITLIST_KEY
)
